import React from 'react';
import { useContent } from '../../content/ContentProvider';

export default function Unavailable() {
  const { reload } = useContent();
  return (
    <div className="col-12 m-auto d-flex flex-column align-items-center justify-content-center text-center px-3 py-5">
      <p>The portfolio is temporarily unavailable.</p>
      <button type="button" className="btn btn-outline-secondary" onClick={reload}>
        Try again
      </button>
    </div>
  );
}
